import React from 'react';
import { useHistory } from 'react-router-dom';
import { AppState, Auth0Provider } from '@auth0/auth0-react';

const Auth0ProviderWithHistory: React.FC = ({ children }) => {
  const domain = process.env.REACT_APP_AUTH0_DOMAIN || '';
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID || '';
  const history = useHistory();

  const onRedirectCallback = (appState: AppState) => {
    history.push(appState?.returnTo || window.location.pathname);
  };

  return (
    <>
      <Auth0Provider
        domain={domain}
        clientId={clientId}
        audience="https://basixbooks/"
        redirectUri={window.location.origin}
        onRedirectCallback={onRedirectCallback}
        // share the session across tabs (item 90): localStorage is per-origin and
        // shared by every tab, so a new tab opened from a sidebar nav item picks up
        // the existing token and silently authenticates — no second login screen.
        // refresh tokens renew it without the third-party-cookie iframe dance.
        cacheLocation="localstorage"
        useRefreshTokens
      >
        {children}
      </Auth0Provider>
    </>
  );
};

export default Auth0ProviderWithHistory;
